import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection15Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/94ze6kdwls`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection15Video;
